import type { RewardCell } from './reward-cell';

/**
 * A Payout matrix as the admin edits it: segment → correct-count tier → reward cell (CONTEXT.md
 * "Payout matrix"). The same shape whether it is a Contest's own snapshot or the
 * `default_payout_matrix` new Contests inherit — the backend validates both against one schema.
 */
export type PayoutMatrixDraft = Record<string, Record<string, RewardCell>>;

/**
 * The payout matrix's segment columns (GL-14), in display order: the default column first,
 * then the registered segments by label. Shared between the detail page's read-only Prizes
 * tab and the editor's payout-matrix editor (CAE-298) — the two views must agree on column
 * order, or an operator edits one column and reads back another.
 */
export function payoutMatrixSegments(segmentRegistry: Record<string, string>): string[] {
  return [
    'default',
    ...Object.entries(segmentRegistry)
      .sort((a, b) => a[1].localeCompare(b[1], undefined, { numeric: true }))
      .map(([id]) => id),
  ];
}
